import React from 'react'
import DropDown from "../../component/dropdown/dropdown"
import i18n from '../../i18n/i18n';
import { withTranslation } from 'react-i18next';
import { I18nextProvider } from 'react-i18next';
// CSS
import "./navbar.css"
// Image
import logo from "../../assets/Calici_LogoType.png"

class Navbar extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      links : [{
          id : "about",
          name : "ABOUT",
          href : "/ceo-message",
          click : null,
          submenu : [{
              id : "ceo-message",
              name : "CEO message",
              href : "/ceo-message",
              click : null
          }, {
              id : "history",
              name : "About us",
              href : "/story",
              click : null
          }, {
              id : "history",
              name : "History",
              href : "/history",
              click : null
          }, {
              id : "map",
              name : "Contact us",
              href : "/map",
              click : null
          }]
      }, {
          id : "R&D",
          name : "Platform Validation",
          href : "/research",
          click : null,
          submenu : []
      }, {
          id : "news",
          name : "NEWS",
          href : "/news",
          // Display posts as frontend only
          // Because the news page is not working
          // So Change links from "/news/public" to "/news/list" (Temporary) - 24.03.19
          click : null,
          submenu : []
      }, {
          id : "pharmaco",
          name : "PHARMACO-NET",
          href : "https://pharmaco-net.org/",
          click : null,
          submenu : []
      }],
      open  : false
    }
  }
  menuButton = () => {
    this.setState({open : !this.state.open})
  }
  handleClick = () => {
    const { i18n } = this.props;
    i18n.changeLanguage(i18n.language === 'en' ? 'ko' : 'en');
  }
  render(){
    const lang = this.props.i18n.language;
    return(
      <I18nextProvider i18n={i18n}>
        <header>
        <div className="inner">
            <a href="/" className="logo">
              <img src={logo} alt="logo"/>
            </a>

            <nav className = {this.state.open ? "on" : ""}>
              <ul className = "nav">
                {this.state.links.map((val, id) =>
                    <DropDown name = {val.name} href = {val.href} click = {val.click} key={"navbar-dd-"+val.name}>
                      {val.submenu.length > 0 ? <ul className = "sub_menu">
                        {val.submenu.map((v, i) => <li key={"navbar-dd-item-"+v.name}><a href={v.href}>{v.name}</a></li>)}
                      </ul> : <></>}
                    </DropDown>
                )}
              </ul>
              <div className='lang-btn' onClick={this.handleClick}>
                <p className={lang === 'en' ? 'active' : ''}>ENG</p>
                <p className={lang === 'ko' ? 'active' : ''}>KOR</p>
              </div>
            </nav>
            <div onClick = {this.menuButton} className={`toggle-btn ${this.state.open ? "on" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
        </div>
        </header>
      </I18nextProvider>
    )
  }
}

export default withTranslation('navbar')(Navbar);
